// src/store/userStore.js
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const useUserStore = create(
  persist(
    (set) => ({
      currUserActive: null,     // Strictly for the Profiles table data
      googleData: null,         // Strictly for the Supabase/Google Auth data
      
      setCurrUserActive: (user) => set({ currUserActive: user }),
      setGoogleData: (data) => set({ googleData: data }),
      
      clearUser: () => set({ currUserActive: null, googleData: null }),
    }),
    {
      name: 'curr-user-storage',
      // Persist both so they are available on page refresh
      partialize: (state) => ({ 
        currUserActive: state.currUserActive, 
        googleData: state.googleData 
      }),
    }
  )
);